import { tw } from '@/utils/tw';

const VideoPlaylist = tw.theme({
  base: [
    'aller-video-container',
    'min-h-[calc(100vw - 96px)]',
    'h-[auto]',
    '[@media(min-width:736px)]:h-[auto]',
    '[@media(min-width:736px)]:min-h-[calc(100vw / 1.7776 / 2)]',
    '[@media(min-width:736px)]:max-h-[485px]',
  ],
});

export default VideoPlaylist;
